module.exports = __webpack_public_path__ + "static/media/jobly.72f1050b.mp4";